module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "soft-cantainer"
  }, [_c('div', {
    staticClass: "soft-main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-box-left"
  }, [_c('div', {
    staticClass: "search-item"
  }, [_c('el-input', {
    attrs: {
      "size": "mini",
      "placeholder": "供应商",
      "prefix-icon": "el-icon-search",
      "clearable": ""
    },
    on: {
      "input": _vm.querySearch
    },
    model: {
      value: (_vm.queryParams.supName),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "supName", $$v)
      },
      expression: "queryParams.supName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('el-input', {
    attrs: {
      "size": "mini",
      "placeholder": "种植体品牌",
      "prefix-icon": "el-icon-search",
      "clearable": ""
    },
    on: {
      "input": _vm.querySearch
    },
    model: {
      value: (_vm.queryParams.implSys),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "implSys", $$v)
      },
      expression: "queryParams.implSys"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('el-input', {
    attrs: {
      "size": "mini",
      "placeholder": "种植体型号",
      "prefix-icon": "el-icon-search",
      "clearable": ""
    },
    on: {
      "input": _vm.querySearch
    },
    model: {
      value: (_vm.queryParams.implModel),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "implModel", $$v)
      },
      expression: "queryParams.implModel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-box-right"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small"
    },
    on: {
      "btnClick": _vm.querySearch
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small"
    },
    on: {
      "btnClick": _vm.querySearch
    }
  }, [_vm._v("重置")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "height": "auto"
    },
    attrs: {
      "element-loading-text": "加载中...",
      "element-loading-background": "rgba(0, 0, 0, 0)"
    }
  }, [_c('div', {
    staticClass: "table-wrap"
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "font-size": "13px"
    },
    attrs: {
      "data": _vm.dataList,
      "header-cell-style": {
        background: '#F5F7FA'
      },
      "size": "small",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": "种植体品牌",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.implSys) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": "种植体型号",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.implModel) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": "扫描杆供应商",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.supName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "扫描杆数据库(点击下载)",
      "width": "300",
      "header-align": "center",
      "align": "center",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "operate"
        }, _vm._l((_vm.getFileArr(scope.row.filePath)), function(val) {
          return _c('p', {
            on: {
              "click": function($event) {
                return _vm.downFile(scope.row.filePath)
              }
            }
          }, [_vm._v("\n                    " + _vm._s(val.name) + "\n                  ")])
        }), 0)]
      }
    }])
  }), _vm._v(" "), (_vm.activeTab == 'mine') ? _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "label": "进度状态",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.delFlag == '0') ? _c('span', [_vm._v("已发布")]) : _vm._e(), _vm._v(" "), (scope.row.delFlag == '2') ? _c('span', [_vm._v("审核中")]) : _vm._e(), _vm._v(" "), (scope.row.delFlag == '3') ? _c('span', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("已驳回")]), _vm._v("\n                  ," + _vm._s(scope.row.remark) + "\n                ")]) : _vm._e()]
      }
    }], null, false, 2983075870)
  }) : _vm._e()], 1), _vm._v(" "), (_vm.noData) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n            暂无数据\n          ")]) : _vm._e(), _vm._v(" "), (_vm.dataList.length) ? _c('div', {
    staticClass: "pagination-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.pageNum,
      "page-size": _vm.queryParams.pageSize,
      "layout": "total,prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "pageNum", $event)
      }
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "center": "",
      "title": _vm.title,
      "width": "30%",
      "visible": _vm.fileDialog,
      "modal-append-to-body": false,
      "destroy-on-close": true,
      "lock-scroll": false
    },
    on: {
      "update:visible": function($event) {
        _vm.fileDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "model": _vm.ruleForm
    }
  }, [_c('div', {
    staticClass: "input-upload-wrap",
    staticStyle: {
      "height": "450px"
    }
  }, [_c('el-form-item', [_c('div', {
    staticClass: "impl-left"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "supName",
      "label": "供应商名称:",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入供应商名称",
      "size": "small"
    },
    model: {
      value: (_vm.form.supName),
      callback: function($$v) {
        _vm.$set(_vm.form, "supName", $$v)
      },
      expression: "form.supName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "impl-left",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "文件名称:",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "上传文件后填充",
      "size": "small",
      "readonly": ""
    },
    model: {
      value: (_vm.form.fileName),
      callback: function($$v) {
        _vm.$set(_vm.form, "fileName", $$v)
      },
      expression: "form.fileName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "25px"
    },
    attrs: {
      "label": "文件上传:"
    }
  }, [_c('el-upload', {
    ref: "upload",
    attrs: {
      "action": "",
      "http-request": _vm.uploadFile,
      "data": {
        objectType: '25',
        objectTag: 'soft_file'
      },
      "limit": 1,
      "on-exceed": _vm.handleExceed,
      "on-remove": function (file, fileList) {
        _vm.handleRemove(file, fileList, '25')
      },
      "file-list": _vm.fileList,
      "auto-upload": true
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("选取文件")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "70px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n                  请上传 大小不超过\n                  "), _c('b', {
    staticStyle: {
      "color": "#f56c6c"
    }
  }, [_vm._v(_vm._s(_vm.fileSize))]), _vm._v("\n                  格式为\n                  "), _c('b', {
    staticStyle: {
      "color": "#f56c6c"
    }
  }, [_vm._v(_vm._s(_vm.fileType.join("/")))]), _vm._v("\n                  的文件\n                ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "impl-left"
  }, [_c('el-form-item', {
    attrs: {
      "label": "文件排序:",
      "label-width": "100px"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "size": "small",
      "disabled": ""
    },
    model: {
      value: (_vm.form.sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "sort", $$v)
      },
      expression: "form.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "10px auto"
    },
    attrs: {
      "prop": "implSysId",
      "label": "植体品牌:",
      "label-width": "100px"
    }
  }, [(_vm.title == '新增数据') ? _c('el-select', {
    staticClass: "distance",
    attrs: {
      "filterable": "",
      "placeholder": "请选择植体品牌",
      "size": "small"
    },
    on: {
      "change": function($event) {
        return _vm.changeImplSys(_vm.form.implSysId)
      }
    },
    model: {
      value: (_vm.form.implSysId),
      callback: function($$v) {
        _vm.$set(_vm.form, "implSysId", $$v)
      },
      expression: "form.implSysId"
    }
  }, _vm._l((_vm.implList), function(item) {
    return _c('el-option', {
      key: item.implId,
      attrs: {
        "label": item.implName,
        "value": item.implId
      }
    })
  }), 1) : _c('el-input', {
    attrs: {
      "placeholder": "请输入植体型号",
      "size": "small"
    },
    model: {
      value: (_vm.form.implModel),
      callback: function($$v) {
        _vm.$set(_vm.form, "implModel", $$v)
      },
      expression: "form.implModel"
    }
  })], 1), _vm._v(" "), (_vm.form.implSysId == '1099') ? _c('el-form-item', {
    attrs: {
      "label": "植体品牌:",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入植体品牌",
      "size": "small"
    },
    model: {
      value: (_vm.form.otherImplSys),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherImplSys", $$v)
      },
      expression: "form.otherImplSys"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "impl-left"
  }, [_c('el-form-item', {
    staticStyle: {
      "margin": "10px auto"
    },
    attrs: {
      "prop": "implModelId",
      "label": "植体型号:",
      "label-width": "100px"
    }
  }, [(_vm.title == '新增数据') ? _c('el-select', {
    staticClass: "distance",
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.form.implModelId),
      callback: function($$v) {
        _vm.$set(_vm.form, "implModelId", $$v)
      },
      expression: "form.implModelId"
    }
  }, _vm._l((_vm.implModelList), function(item) {
    return _c('el-option', {
      key: item.implId,
      attrs: {
        "label": item.implName,
        "value": item.implId
      }
    })
  }), 1) : _c('el-input', {
    attrs: {
      "placeholder": "请输入植体型号",
      "size": "small"
    },
    model: {
      value: (_vm.form.implModel),
      callback: function($$v) {
        _vm.$set(_vm.form, "implModel", $$v)
      },
      expression: "form.implModel"
    }
  })], 1), _vm._v(" "), (_vm.form.implSysId == '1099') ? _c('el-form-item', {
    attrs: {
      "label": "植体型号:",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入植体型号",
      "size": "small"
    },
    model: {
      value: (_vm.form.otherImplModel),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherImplModel", $$v)
      },
      expression: "form.otherImplModel"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注信息:",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "留言至管理员"
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", $$v)
      },
      expression: "form.remark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-left": "68%"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.fileDialog = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "soft-header"
  }, [_c('h2', [_vm._v("软件下载")]), _vm._v(" "), _c('p', [_vm._v("2024-04-10 09:51:51")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5505e053","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/software.vue
// module id = 656
// module chunks = 0